import '@/icon';
import axios from 'axios';
import { resolveApiBaseUrl } from './utils/apiBaseUrl';
import { installResponseEncryption, createEncryptedUploadRequest } from './utils/responseEncryption';
import originalUploadRequest from 'element-ui/packages/upload/src/ajax';
import ElementUI, { Message } from 'element-ui'; //全局引入element
import 'element-ui/lib/theme-chalk/index.css'; //全局引入element的样式
import Vue from 'vue';
import App from './App.vue';
import router from './router/router.js'; // 导入路由文件

import store from './store/index';

import * as echarts from 'echarts';
import 'echarts-gl';


import VueClipboard from 'vue-clipboard2';
import VueCron from 'vue-cron';

import NProgress from 'nprogress';

import 'nprogress/nprogress.css';

import ElementResizeDetectorMaker from "element-resize-detector";

Vue.prototype.$erd = ElementResizeDetectorMaker()
Vue.use(VueCron);

if (process.env.VUE_APP_RESPONSE_ENCRYPTION_ENABLED === 'true') {
    ElementUI.Upload.props.httpRequest = { type: Function, default: createEncryptedUploadRequest(axios, originalUploadRequest) };
}
Vue.use(ElementUI)

// 将 jwt_decode 添加到 Vue 的原型中，以便在组件中全局访问

Vue.use(VueClipboard)

Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
Vue.use(ElementUI);    //全局注入element

// 本地
// axios.defaults.baseURL = 'http://localhost:8080/api'


// axios.defaults.baseURL = 'http://localhost:8009/api'
axios.defaults.baseURL = resolveApiBaseUrl(process.env.VUE_APP_API_BASE_URL, window.location.href)
// axios.defaults.baseURL = 'http://192.168.31.80:8009/api';
//axios.defaults.baseURL = 'https://www.nhniudan.com/api';
// axios.defaults.baseURL = 'http://183.6.115.74:8080/api'

// 本地-pro
// axios.defaults.baseURL = 'http://192.168.31.148:8009/api'

// axios.defaults.baseURL = 'http://192.168.31.143:5001/api'

// ip
//  axios.defaults.baseURL = 'http://192.168.30.211:8009/api';

// 服务器
// axios.defaults.baseURL = 'http://www.nhniudan.com/api';
//axios.defaults.baseURL = 'http://www.nhniudan.com/api';
//axios.defaults.baseURL = 'http://niudan.vip.cpolar.cn/api';
// axios.defaults.baseURL = 'http://niudan.vip.cpolar.cn/api';


axios.defaults.withCredentials = true;
installResponseEncryption(axios, {
    enabled: process.env.VUE_APP_RESPONSE_ENCRYPTION_ENABLED === 'true'
});
let lastDeployingMessageAt = 0;
const deployingMessage = '服务器正在发布新版本，请稍后再试。如果当前正在执行其他操作，请在发布完成后再验证数据；发布版本期间可能会导致部分数据保存失败。';

function isDeployingMessageRecentlyShown() {
    return Date.now() - lastDeployingMessageAt < 5000;
}

function showDeployingMessage(message) {
    lastDeployingMessageAt = Date.now();
    Message({
        type: 'error',
        message: message || deployingMessage,
        duration: 6000
    });
}

// 设置请求拦截器，在发送请求前加入token到请求头
axios.interceptors.request.use(
    config => {
        if (config.preserveUploadHeaders) return config;
        const token = store.getters.getToken;
        const expirationTime = store.getters.getExpirationTime;
        // 如果存在 token 并且过期时间大于当前时间，则刷新 token
        if (token && Date.now() > expirationTime) {
            Message({
                type: "warning",
                message: "登陆过期，请重新登陆!",
            });
            // 移除token
            store.commit('clearTokenOut');

            // 删除即将发出的过期 token，避免触发后端 403
            delete config.headers.Authorization;
            // 延迟跳转，避免当前请求尚未结束时触发路由切换
            setTimeout(() => {
                router.push('/login');
            }, 500);
            return Promise.reject(new Error('登录已过期'));
        }

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 响应拦截器
axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.code === 'RESPONSE_ENCRYPTION_UNAVAILABLE' || error.code === 'RESPONSE_DECRYPTION_FAILED') {
            Message({ type: 'error', message: error.message });
            return Promise.reject(error);
        }
        console.log('error', error)

        // 没有服务器响应（网络错误、后端暂不可用等）
        if (!error.response) {
            if (!isDeployingMessageRecentlyShown()) {
                Message({
                    type: 'error',
                    message: '系统报错了，请检查网络或联系管理员'
                });
            }
            return Promise.reject(error);
        }

        const response = error.response;
        console.log('HTTP status:', response.status, response.data)
        if ([502, 503, 504].includes(response.status)) {
            const message = response.data && response.data.msg
                ? response.data.msg
                : deployingMessage;
            showDeployingMessage(message);
            return Promise.reject(error);
        }

        if (response.status === 403) {
            Message({
                type: 'error',
                message: '没有权限访问，请先登录!'
            });
            // 移除 token 并跳转登录
            store.commit('clearTokenOut');
            setTimeout(() => {
                router.push('/login');
            }, 300);
        }
        // 401 未认证
        else if (response.status === 401) {
            Message({
                type: 'error',
                message: '登录已过期，请重新登录!'
            });
            store.commit('clearTokenOut');
            setTimeout(() => {
                router.push('/login');
            }, 300);
        }
        console.log('拦截器', error)
        // 对响应错误做些什么
        // 可以在这里捕获和处理请求错误，并将错误信息传递给前端
        return Promise.reject(error);
    }
)

Vue.config.productionTip = false;

Vue.prototype.$previousRoute = null;

// vuex路由设置
router.beforeEach((to, from, next) => {
  let user = store.getters.getToken;
  var resultString;
  if(user != null ) {
  var valuesArray = Object.values(user); // 获取对象的值数组
  resultString = valuesArray.join(''); // 将值数组连接成一个字符串，无分隔符
  }
  if (to.path.startsWith('/login')) {
    next()
  } else if(user == null){
      Message({
        type: 'error',
        message: '请先登录!'
      });
      next({
        path: '/login'
      })
  } else if(to.fullPath.startsWith('/index') ) {
      // if(resultString === 'admin') {
      //   next()
      // } else {
      //   alert("没有权限，不能访问！")
      //   next({
      //     path:'/'
      //   })
      // }
      next()
  }

    Vue.prototype.$previousRoute = from;

    NProgress.start();

    let token = store.getters.getToken;
    if (to.path.startsWith('/login')) {
        next()
    } else if (token == null) {
        Message({
            type: 'error',
            message: '请先登录!'
        });
        next({
            path: '/login'
        })
    } else if (to.fullPath.startsWith('/index')) {
        next()
    } else {
      next()
    }
})


router.afterEach(() => {
    NProgress.done();
});


Vue.prototype.$axios = axios
new Vue({
    router,
    render: h => h(App),
    store,
}).$mount('#app')


